import attack from '../../../request/request'
import { EMER } from '../../requers_variable'
export default {
  // 获取系统版本号
  version() {
    return new Promise((resolve, reject) => {
      attack({
        type: 'get',
        url: '../../../static/version.txt',
        success(data) {
          resolve(data.data)
        },
        error(err) {
          reject(false)
        }
      })
    })
  },
    /**
   * 预案概要
   * 
   * @param {any} params 
   * @returns 
   */
  heavypoll_detail(planId) {
    return new Promise(function(resolve, reject) {
      attack({
        type: 'get',
        url: `${EMER}/heavypoll/ent/info/detail`,
        data: planId,
        success(rep) {
          resolve({
            state: true,
            data: rep.data
          })
        },
        error(err) {
          resolve({
            state: false
          })
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/data/basic/others/other.js